import React from 'react';

type UseAlarmsProps = {
    alarm?: {
        color?: string | null;
        is_flashing?: boolean | number | string | null;
    } | null;
};

export const useAlarms = ({ alarm }: UseAlarmsProps) => {
    const [color, setColor] = React.useState(alarm?.color ?? 'transparent');

    const setAlarmColor = React.useCallback(
        (nextColor?: string | null) => {
            setColor(nextColor ?? alarm?.color ?? 'transparent');
        },
        [alarm?.color]
    );

    React.useEffect(() => {
        setAlarmColor();
    }, [setAlarmColor]);

    const isFlashing =
        alarm?.is_flashing === true ||
        alarm?.is_flashing === 1 ||
        alarm?.is_flashing === '1';

    return {
        color,
        setAlarmColor,
        isFlashing,
    };
};
